import axios from "axios";
import qs from 'query-string';
import { Dialog, Notify } from "vant";
import { router } from "../router";
import store from "./store";

const promiseMap = new Map();
const CancelToken = axios.CancelToken;
const source = CancelToken.source();

const httpService = (httpMethod) => (url, data, disableAutoAlert) => {

  let requestKey = httpMethod+'|'+url;
  if (data) {
      requestKey = requestKey + '|' + JSON.stringify(data);
  }
  let promise = promiseMap.get(requestKey)
  //合并并发的相同请求
  if (promise) {
      return promise;
  }

  promise = new Promise((resolve, reject) => {
      let tokenValue =  localStorage.getItem('token');
      const user = store.state.user;
      if (!tokenValue && user && user.token) {
        tokenValue = user.token
      }
      store.setLoading(true);
      axios({
          method: httpMethod,
          headers: {'X-Token': tokenValue || ''},
          url: '/json' + url,
          params: httpMethod === 'get' ? data : null,
          data: data,
          paramsSerializer: params => {
            return qs.stringify(params)
          },
          cancelToken: source.token
      }).then(resp => {
        store.setLoading(false);
        resolve(resp.data);
        promiseMap.delete(requestKey)
      })
      .catch(error => {
        store.setLoading(false);
          if (axios.isCancel(error)) {
              console.log('Request canceled');
          } else if (error.response) {
              const status = error.response.status;
              if (status === 401 && location.pathname != '/login') {
                  console.log('401未登录,重定向...')
                  Dialog.alert({
                    message: '您太久没有操作, 需要刷新后才能继续',
                  }).then(() => {
                    const callback = window.location.pathname + window.location.search;
                    const redirect = '/login?redirect_uri=' + encodeURIComponent(callback)
                    router.push(redirect);
                  });
              }
              else if (status === 403) {
                  Notify("您没有此权限");
              }
              else if (error.response.data && !disableAutoAlert) {
                Notify(error.response.data.result);
              }
          } else if (error.message === 'Network Error') {
            Notify("网络错误,请检查您的网络.");
          } else {
              console.error(error)
              Notify(error.message || '错误');
          }
          reject(error);
          promiseMap.delete(requestKey)
      });
  });
  promiseMap.set(requestKey, promise);
  return promise;
}

const HttpPlugin = {
  install : function(Vue) {
    Vue.prototype.$http = {
      get: httpService('get'),
      post: httpService('post'),
      cancel: source.cancel
    };

  }
}

export default HttpPlugin;